import React, { useMemo, useState } from 'react';
import { Download, Smartphone, X } from 'lucide-react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.revstar.merchant';

const AuthInstallWidget = () => {
  const [showInstallGuide, setShowInstallGuide] = useState(false);

  const installPlatform = useMemo(() => {
    if (typeof navigator === 'undefined') return 'desktop';
    const ua = navigator.userAgent || navigator.vendor || window.opera || '';
    if (/android/i.test(ua)) return 'android';
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return 'ios';
    }
    return 'desktop';
  }, []);

  const installCopy = useMemo(() => {
    if (installPlatform === 'ios') {
      return 'To install this app on your iOS device, tap the Share icon in Safari, then select "Add to Home Screen".';
    }
    if (installPlatform === 'android') {
      return 'Install the Revstar merchant app from Google Play.';
    }
    return 'Install the Revstar merchant app from Google Play on your Android device.';
  }, [installPlatform]);

  return (
    <div className="srx-install-widget">
      {!showInstallGuide && (
        <button
          type="button"
          className="srx-install-trigger"
          onClick={() => setShowInstallGuide(true)}
          aria-expanded={showInstallGuide}
          aria-label="Install Revstar app"
        >
          <Download size={16} aria-hidden="true" />
          <span>Install App</span>
        </button>
      )}

      {showInstallGuide && (
        <div className="srx-install-popover" role="dialog" aria-label="Install Revstar app">
          <button
            type="button"
            className="srx-install-close"
            onClick={() => setShowInstallGuide(false)}
            aria-label="Close install instructions"
          >
            <X size={15} aria-hidden="true" />
          </button>
          <div className="srx-install-icon" aria-hidden="true">
            <Smartphone size={18} />
          </div>
          <h2>Install Revstar</h2>
          <p>{installCopy}</p>
          {installPlatform !== 'ios' && (
            <a className="srx-install-link" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              Open Play Store
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default AuthInstallWidget;
